import axios from 'Axios';

export default {
  getSlip(id) {
    return axios.get('/slip/' + id);
  },
  getShortlistedSlip(id) {
    return axios.get(`/slip/${id}/shortlisted`);
  },
  getCircularEconomy(id) {
    return axios.get(`/circular_economy/ticket/slip/${id}`);
  },
  getCircularEconomyShortlisted(id) {
    return axios.get(`/circular_economy/ticket/slip/${id}/answers`);
  },
  editSlip(id, data) {
    return axios.post(`/slip/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  saveSpecification(id, data) {
    return axios.post(`/slip/${id}/shortlisted`, data);
  },
  saveSpecificationDraft(id, data) {
    return axios.post(`/slip/${id}/draft`, data);
  },
  saveSpecificationUnDraft(id, data) {
    return axios.post(`/slip/${id}/undraft`, data);
  },
  addQuotation(id, data) {
    return axios.post(`/slip/${id}/create_slip_assets`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getDetails(slipId) {
    return axios.get(`/slip/${slipId}/shortlisted`);
  },
  slipDeal(slipId) {
    return axios.put(`slip/${slipId}/deal`);
  },
};
